import { useState, useEffect } from "react";

export const useDebounce = (value, delay) => {
  const [debounce, setDebounce] = useState("");
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebounce(value);
    }, delay);
    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);
  return debounce;
};



// export const showData = (first, second, third) => {
//   return first ? first :  second ? second :  third ?  third: "0"
// }

  export const showData = (first, second, third) => {
    return first ?? second ?? third ?? "0";
  };


  export default function trimSearchValue(prev) {
    return {
      ...prev,
      search_value: prev?.search_value?.trim()
    };
  }
  